const columnsListData = [
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    key: 'startDate',
  },
  {
    title: 'Start Time',
    dataIndex: 'startTime',
    key: 'startTime',
  },

  {
    title: 'Tags',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    editable: true,
  },
  {
    title: 'Deadline',
    dataIndex: 'deadline',
    key: 'deadline',
    editable: true,
  },
];

export default columnsListData;
